import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartCtx = createContext(null);
const keyOf = (id, size, text, addons, flavors) => [id, size || "", (text || "").trim().toUpperCase(), [...(addons || [])].sort().join("+"), [...(flavors || [])].sort().join("+")].join("|");
export const countLetters = (t) => (t || "").replace(/[^a-z0-9]/gi, "").length;

export function CartProvider({ children }) {
  const [items, setItems] = useState(() =>
    JSON.parse(localStorage.getItem("l3_cart") || "[]").map((i) => ({ ...i, key: i.key || keyOf(i.id, i.size, i.text) }))
  );
  useEffect(() => localStorage.setItem("l3_cart", JSON.stringify(items)), [items]);

  const value = useMemo(() => {
    const add = (p, qty = 1, opts = {}) =>
      setItems((cur) => {
        const key = keyOf(p.id, opts.size, opts.text, opts.addons, opts.flavors);
        const ex = cur.find((i) => i.key === key);
        if (ex) return cur.map((i) => (i.key === key ? { ...i, quantity: Math.min(50, i.quantity + qty) } : i));
        const sizePrice = p.sizes?.find((s) => s.label === opts.size)?.price ?? p.price;
        const letters = p.per_letter ? countLetters(opts.text) : null;
        const addons = opts.addons || [];
        const addonTotal = (p.addons || []).filter((a) => addons.includes(a.label)).reduce((s, a) => s + a.price, 0);
        return [...cur, {
          key, id: p.id, name: p.name, image_url: p.image_url, quantity: qty, shippable: !!p.shippable,
          size: opts.size || null, text: p.per_letter ? opts.text.trim() : null, letters, addons, flavors: opts.flavors || [],
          price: sizePrice * (letters || 1) + addonTotal,
        }];
      });
    const setQty = (key, q) => setItems((cur) => cur.map((i) => (i.key === key ? { ...i, quantity: Math.max(1, Math.min(50, q)) } : i)));
    const remove = (key) => setItems((cur) => cur.filter((i) => i.key !== key));
    const clear = () => setItems([]);
    const count = items.reduce((s, i) => s + i.quantity, 0);
    const total = items.reduce((s, i) => s + i.quantity * i.price, 0);
    return { items, add, setQty, remove, clear, count, total };
  }, [items]);

  return <CartCtx.Provider value={value}>{children}</CartCtx.Provider>;
}

export const useCart = () => useContext(CartCtx);
